import { createAsyncThunk } from '@reduxjs/toolkit';
import { createSearchParams, NavigateFunction, NavigateOptions, To } from 'react-router-dom';

import { RootState } from '../store';

export const navigateAction = createAsyncThunk<
  void,
  {
    to: To;
    options?: NavigateOptions;
    searchParams?: Record<string, string | string[]>;
    navigate: NavigateFunction;
  },
  {
    state: RootState;
  }
>('navigateAction', async ({ to, searchParams, navigate }, { getState }) => {
  const { groups } = getState().appDetails;
  const filteredGroups = groups.filter((g) => g !== 'directSmallBusiness');
  if (typeof to === 'string') {
    const [pathname, hash] = to.split('#');
    navigate({
      pathname,
      hash,
      search: `?${createSearchParams({
        ...searchParams,
        group: filteredGroups,
      })}`,
    });
  } else {
    navigate({
      ...to,
      search: `?${createSearchParams({
        ...searchParams,
        group: filteredGroups,
      })}`,
    });
  }
});
